import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Batch } from './batch.interface';
import { BatchService } from './batch.service';
import { StoreState } from '../../models/store.interface';

const service = new BatchService();

export interface BatchState {
   batches: Array<Batch>;
}

const BatchStore: Module<BatchState, StoreState> = {
   namespaced: true,
   state: {
      batches: [],
   },
   getters: {},
   mutations: {
      SET_BATCHES(state, batches: Array<Batch>) {
         state.batches = batches;
      },
      ADD_BATCH(state, batch: Batch) {
         state.batches.push(batch);
      },
      REMOVE_BATCH(state, batch: Batch) {
         const batchIndex = state.batches.findIndex((b) => b.id === batch.id);
         if (batchIndex > -1) state.batches.splice(batchIndex, 1);
      },
      SET_BATCH(state, batch: Batch) {
         const batchIndex = state.batches.findIndex((b) => b.id === batch.id);
         if (batchIndex > -1) state.batches.splice(batchIndex, 1, batch);
         else state.batches.push(batch);
      },
   },
   actions: {
      async getBatches(context, query?: LocationQuery) {
         const response = await service.getBatches(query);
         context.commit('SET_BATCHES', response.data || []);
      },
      async getBatch(context, batchId: number) {
         return await service.getBatch(batchId);
      },
   },
};

export default BatchStore;
